import { useParams } from "react-router-dom";
import {
  HomeStyled,
  CxControle,
  ModalStyledAllAvisoEmergencia,
  ModalStyledBaixaApp,
} from "../../Styles/Home";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil, NewHeader } from "../../components/Header";
import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../../Context/ContextHome";
import iconeEstacao from "../../Assets/Icons/iconElevatoria.svg";
import iconeGrade from "../../Assets/Icons/iconGradee.svg";
import { LogoBG } from "../../components/logoBG";
import { apiSae } from "../../services/api";
import { AiOutlineAlert, AiTwotoneAlert, AiFillAlert } from "react-icons/ai";
import { IoClose, IoLogoApple, IoMoon } from "react-icons/io5";
import { IoMdCloudDownload } from "react-icons/io";
import { ImAndroid } from "react-icons/im";
import { SquareLoading } from "../../components/loaders";
import { PocoHome } from "../../components/poco";
import statusPump from "../../Assets/Icons/pump.png";
import statusPumpON from "../../Assets/Icons/pumpOn.png";
import { PiFanFill } from "react-icons/pi";
import imgGrade from "../../Assets/Icons/GradeOff.png";
import imgGradeOn from "../../Assets/Icons/GradeOn_A.png";
import { FaSun } from "react-icons/fa";

export const Home = () => {
  const {
    navigate,
    headerApi,
    infoEstacao,
    userOn,
    socket,
    modalAvisosEmegencia,
    setModalAvisosEmegencia,
    modalBaixarApp,
    setModalBaixarApp,
    aoListarEstacoes,
    loading,
    darkMode,
    setDarkMode,
  } = useContext(HomeContext);

  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);
  const [statusPoco, setStatusPoco] = useState({});
  const [abreModarBaixar, setAbreModalBaixar] = useState(false);

  const verifStatusGtwPoco = async (idGTw) => {
    if (!idGTw) {
      return false;
    } else {
      try {
        const status = await apiSae.get(`/users/gtw/${idGTw}`, headerApi);

        return status.data.online;
      } catch (error) {
        return false;
      }
    }
  };

  useEffect(() => {
    const fetchStatuses = async () => {
      const newStatuses = {};

      for (const estacao of infoEstacao || []) {
        if (estacao.pocos.length > 0) {
          newStatuses[estacao.id] = await verifStatusGtwPoco(
            estacao.pocos[0].gtw_poco
          );
        } else if (estacao.grades.length > 0) {
          newStatuses[estacao.id] = await verifStatusGtwPoco(
            estacao.grades[0].gtw_poco
          );
        }
      }

      setStatusPoco(newStatuses);
    };

    fetchStatuses();
    ListAlerts();
  }, [infoEstacao, userOn]); // Executa quando `elevatorias.pocos` mudar

  useEffect(() => {
    if (socket) {
      socket.on("update_avisoEmergencia", () => {
        ListAlerts();
      });
    }
  }, [socket]);

  useEffect(() => {
    if (modalBaixarApp) {
      document.body.classList.add("modal-open"); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove("modal-open"); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalBaixarApp]);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setAbreModalBaixar(true);
    }
    aoListarEstacoes(1, true);
  }, []);

  const ListAlerts = async () => {
    try {
      const AlertaList = await apiSae.get(
        `/avisoEmergencia/LeituraEmegencia`,
        headerApi
      );
      setAlerEmergenciaList(AlertaList.data);
    } catch (error) {
      console.log(error);
    }
  };

  const calcularPorcentagem = (valorAtual, valorMaximo) => {
    return (valorAtual / valorMaximo) * 100;
  };

  return (
    <HomeStyled darkmode={darkMode}>
      {loading && <SquareLoading />}
      <Header pgAdmin={true} />
      {/* <NewHeader /> */}
      <HeaderMobil pgAdmin={true} />
      {modalBaixarApp && <ModalBaixaApp />}
      {modalAvisosEmegencia && <ModalAvisoEmergencia />}
      <LogoBG />

      <div
        className="darkmode"
        onClick={() => {
          localStorage.setItem("SaeDarkMode", !darkMode);
          setDarkMode(!darkMode);
        }}
      >
        <FaSun className="iconMode icone01" />
        <IoMoon className="iconMode icone02" />
        <span></span>
      </div>

      <div className="IconAlerte">
        <button onClick={() => setModalAvisosEmegencia(true)}>
          {alerEmergenciaList.length > 0 ? (
            alerEmergenciaList.some(
              (alerta) => alerta.status === "pendente"
            ) ? (
              <AiFillAlert className="iconStyledAlertEmegencia" />
            ) : (
              <AiTwotoneAlert className="iconStyledAlertPorcesso" />
            )
          ) : (
            <AiOutlineAlert className="iconStyledAlert" />
          )}
        </button>
      </div>

      <div className="conteinerUnidade">
        <div className="conteudoRolavel">
          <div className="botoes">
            {infoEstacao.map((unidade) => {
              const StatusPocoOn = statusPoco[unidade.id];
              const AlertaEstacao = alerEmergenciaList.filter(
                (idEstacao) => idEstacao.estacao.id === unidade.id
              );

              return (
                unidade.ativo && (
                  <button
                    key={unidade.codigo}
                    onClick={() => {
                      if (unidade.pocos.length > 0) {
                        navigate(`/elevatoria/${unidade.codigo}`);
                      } else if (unidade.grades.length > 0) {
                        navigate(`/grade/${unidade.codigo}`);
                      }
                    }}
                  >
                    <div className="IconAlerte">
                      {AlertaEstacao.length > 0 &&
                        (AlertaEstacao.some(
                          (alerta) => alerta.status === "pendente"
                        ) ? (
                          <AiFillAlert className="iconStyledAlertEmegencia" />
                        ) : (
                          <AiTwotoneAlert className="iconStyledAlertPorcesso" />
                        ))}
                    </div>
                    <h3 className="nomePoco">{unidade.nome_estacao}</h3>

                    <div className="PocoConteiner">
                      <span
                        className={`statusOnUnidade ${
                          StatusPocoOn && "statusOn"
                        }`}
                      />

                      {unidade.grades.map((poco) => {
                        return (
                          <div className="statusPainel" key={poco.id}>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 1
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Auto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 2
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Remoto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 0
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Manual</p>
                            </div>
                          </div>
                        );
                      })}

                      {unidade.pocos.map((poco) => {
                        return (
                          <div className="statusPainel" key={poco.id}>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 1
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Auto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 2
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Remoto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 0
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Manual</p>
                            </div>
                          </div>
                        );
                      })}

                      {unidade.pocos.length > 0 && (
                        <PocoHome
                          alturaAtual={calcularPorcentagem(
                            unidade.pocos[0].nivel_atual,
                            unidade.pocos[0].altura_poco
                          )}
                          nivelExtravasor={calcularPorcentagem(
                            unidade.pocos[0].nivel_maximo,
                            unidade.pocos[0].altura_util_poco
                          )}
                          nivelMinimo={calcularPorcentagem(
                            unidade.pocos[0].nivel_minimo,
                            unidade.pocos[0].altura_util_poco
                          )}
                        />
                      )}
                      {unidade.grades.length > 0 && (
                        <img
                          src={
                            unidade.grades[0].automatico === 1
                              ? imgGradeOn
                              : imgGrade
                          }
                          alt=""
                          className="grandehome"
                        />
                      )}

                      {unidade.pocos.length > 0 && (
                        <div className="BombaInfo">
                          {unidade?.pocos?.map((poco) =>
                            poco?.bombas
                              ?.slice() // faz uma cópia para não alterar o array original
                              .sort((a, b) => a.id - b.id) // ordena pelo id
                              .map((bomba, index) => {
                                if (index == 2) {
                                  if (bomba.status === 0) {
                                    return null; // Pula a renderização se a condição for atendida
                                  }
                                }
                                return (
                                  <div
                                    className="conteinerBomba"
                                    key={bomba.id}
                                  >
                                    <div className="TituloBomba">
                                      <h3>Bomba - {index + 1}</h3>
                                      {/* <div
                                                              className={`iconHomeBomba ${
                                                                bomba.status === 1 && "GiroBomba"
                                                              }`}
                                                            >
                                                              <PiFanDuotone />
                                                            </div> */}
                                    </div>
                                    <div className="imgBomba">
                                      <img src={statusPump} alt="" />
                                      {/* <img src={imgBomba} alt="" /> */}

                                      {/* {bomba.status === 1 ? (
                                        <img src={statusPumpON} alt="" />
                                      ) : (
                                        <img src={statusPump} alt="" />
                                      )} */}
                                      {/* <img
                                        src={statusPump}
                                        alt=""
                                        className="imgFundo"
                                      /> */}

                                      <div
                                        className={`iconHomeBomba ${
                                          bomba.status === 2
                                            ? "falhaBomba"
                                            : bomba.status === 1 && "GiroBomba"
                                        }`}
                                      >
                                        {/* <PiFanDuotone /> */}
                                        <PiFanFill className="iconN" />
                                      </div>
                                    </div>

                                    <div className="divControlerConteiner">
                                      <div className="divControler">
                                        <p
                                          className={
                                            bomba.status == 2
                                              ? "falha"
                                              : bomba.status === 1
                                              ? "ligada"
                                              : "desligada"
                                          }
                                        >
                                          {bomba.status == 2
                                            ? "Falha"
                                            : bomba.status === 1
                                            ? "Ligada"
                                            : "Desligada"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          )}
                        </div>
                      )}
                    </div>

                    {/* {unidade.pocos.length > 0 && (
                      <img src={iconeEstacao} alt="" />
                    )}

                    {unidade.grades.length > 0 && (
                      <img src={iconeGrade} alt="" />
                    )}

                    <span
                      className={`statusOnUnidade ${
                        StatusPocoOn && "statusOn"
                      }`}
                    />
                    {unidade.pocos.length > 0 &&
                      unidade.pocos.map((poco) => {
                        return (
                          <div className="statusPainel">
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 1
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Auto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 2
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Remoto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 0
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Manual</p>
                            </div>
                          </div>
                        );
                      })}
                    {unidade.grades.length > 0 &&
                      unidade.grades.map((grade) => {
                        return (
                          <div className="statusPainel">
                            <div className="divControler">
                              <CxControle
                                activo={
                                  grade.automatico == 1
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Auto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  grade.automatico == 2
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Remoto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  grade.automatico == 0
                                    ? "var(--cor-infor)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Manual</p>
                            </div>
                          </div>
                        );
                      })} */}
                  </button>
                )
              );
            })}
          </div>
        </div>
      </div>

      <div className="IconBaixaApp">
        {!abreModarBaixar && (
          <button
            onClick={() => {
              setModalBaixarApp(true);
            }}
          >
            <IoMdCloudDownload className="Icon" />
            <p>Baixe o App!</p>
          </button>
        )}
      </div>

      <Footer relative={true} background={true} />
    </HomeStyled>
  );
};

export const ModalAvisoEmergencia = ({}) => {
  const { headerApi, setModalAvisosEmegencia, socket, userOn } =
    useContext(HomeContext);

  const [sectionSelect, setSectionSelect] = useState(true);
  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);

  const listAlerts = async () => {
    try {
      const response = await apiSae.get(
        `/avisoEmergencia/LeituraEmegencia`,
        headerApi
      );
      setAlerEmergenciaList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    listAlerts();
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("update_avisoEmergencia", () => {
        listAlerts();
      });
    }
  }, [socket]);

  return (
    <ModalStyledAllAvisoEmergencia>
      <div className="conteiner">
        <span
          className="Closemodal"
          onClick={() => setModalAvisosEmegencia(false)}
        >
          <IoClose />
        </span>

        <div className="SelectSections">
          <h2 className={"sectionAtive"}>Alertas</h2>
        </div>

        <section>
          {alerEmergenciaList.length > 0 ? (
            <ul className="ulHistorico">
              {alerEmergenciaList.map((alerta) => {
                const dataErro = new Date(alerta.createdAt);
                const agora = new Date();
                const diffMs = agora - dataErro; // Diferença em milissegundos
                const diffMin = Math.floor(diffMs / 60000); // Converter para minutos
                const diffHoras = Math.floor(diffMin / 60);
                const diffDias = Math.floor(diffHoras / 24);

                let tempoDecorrido = "";
                if (diffDias > 0) {
                  tempoDecorrido = `${diffDias} dia(s)`;
                } else if (diffHoras > 0) {
                  tempoDecorrido = `${diffHoras} hora(s)`;
                } else {
                  tempoDecorrido = `${diffMin} minuto(s)`;
                }
                return (
                  <li
                    className={`${
                      alerta.status === "pendente" ? "pedente" : "manuteçao"
                    }`}
                  >
                    <span className="iconStyled">
                      <AiOutlineAlert />
                    </span>
                    <div className="Status">
                      <span className="top">Estação:</span>
                      <p>{alerta.estacao.nome_estacao}</p>
                    </div>

                    <div className="Status">
                      <span className="top">Status:</span>
                      {alerta.status === "pendente" ? (
                        <span className="Statusalert">Aguardando análise</span>
                      ) : (
                        <span className="Statusalert">Em manutenção</span>
                      )}
                    </div>
                    <div className="Status">
                      <span className="top">Alerta:</span>
                      <p> {alerta.descricao}</p>
                    </div>
                    <div className="Status">
                      <span className="top">Tempo Decorrido:</span>
                      <span>{tempoDecorrido}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="alertsOk">
              <h2>Nenhum alerta ativo. Tudo certo!</h2>
            </div>
          )}
        </section>
      </div>
    </ModalStyledAllAvisoEmergencia>
  );
};

export const ModalBaixaApp = ({}) => {
  const { modalBaixarApp, setModalBaixarApp } = useContext(HomeContext);

  const handleDownload = () => {
    const fileUrl = "Apk/brk.apk";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "brk.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setModalBaixarApp(false);
  };

  return (
    <ModalStyledBaixaApp>
      <div className="conteiner">
        <div className="titleModal">
          <h2>Baixe o App BRK Connect</h2>
          <span className="Closemodal" onClick={() => setModalBaixarApp(false)}>
            <IoClose />
          </span>
        </div>

        <div className="BotoesApps">
          <button onClick={handleDownload}>
            <ImAndroid className="IconApps" />
            <p>Android</p>
          </button>
          <button disabled={true}>
            <IoLogoApple className="IconApps" />
            <p>IOS</p>
          </button>
        </div>
      </div>
    </ModalStyledBaixaApp>
  );
};
